module.exports = __webpack_public_path__ + "img/modelo-cantina-gal-2.3feb7e8c.jpg";